export { default as WLSliderWithControls } from "./SliderWithControls.vue";
